export default __webpack_public_path__ + "static/media/Guesswho1.7ffde768.PNG";